class BundleCart {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.bindBundleForms();
    });
  }

  bindBundleForms() {
    const bundleForms = document.querySelectorAll('.product-bundles__form');
    
    bundleForms.forEach(form => {
      form.addEventListener('submit', this.handleBundleSubmit.bind(this));
    });
  }

  async handleBundleSubmit(event) {
    event.preventDefault();
    
    const form = event.target;
    const submitButton = form.querySelector('.product-bundles__cta');
    const originalText = submitButton.textContent;
    
    // Show loading state
    submitButton.textContent = 'Adding to Cart...';
    submitButton.disabled = true;
    
    try {
      const formData = new FormData(form);
      const bundleItems = this.extractBundleItems(formData);
      
      // Add all bundle items to cart
      await this.addBundleToCart(bundleItems);
      
      // Show success state
      submitButton.textContent = 'Added to Cart!';
      submitButton.style.backgroundColor = '#28a745';
      
      // Update cart UI
      this.updateCartUI();
      
      // Reset button after delay
      setTimeout(() => {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
        submitButton.style.backgroundColor = '';
      }, 2000);
      
    } catch (error) {
      console.error('Bundle add to cart error:', error);
      
      // Show error state
      submitButton.textContent = 'Error - Try Again';
      submitButton.style.backgroundColor = '#dc3545';
      
      // Reset button after delay
      setTimeout(() => {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
        submitButton.style.backgroundColor = '';
      }, 2000);
    }
  }

  extractBundleItems(formData) {
    const items = [];
    const mainProductId = formData.get('id');
    
    // Add main product
    if (mainProductId) {
      items.push({
        id: mainProductId,
        quantity: 1
      });
    }
    
    // Add additional bundle items
    const formDataEntries = Array.from(formData.entries());
    formDataEntries.forEach(([key, value]) => {
      if (key.startsWith('items[') && key.includes('][id]')) {
        const quantityKey = key.replace('][id]', '][quantity]');
        const quantity = formData.get(quantityKey) || '1';
        
        items.push({
          id: value,
          quantity: parseInt(quantity)
        });
      }
    });
    
    return items;
  }

  async addBundleToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  updateCartUI() {
    // Trigger cart update events that Shopify theme might be listening for
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    // Update cart count if cart icon bubble exists
    const cartBubble = document.querySelector('.cart-icon-bubble');
    if (cartBubble) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const itemCount = cart.item_count;
          if (cartBubble.querySelector('span')) {
            cartBubble.querySelector('span').textContent = itemCount;
          }
        })
        .catch(error => console.error('Error updating cart count:', error));
    }

    // Open cart drawer if it exists
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      setTimeout(() => cartDrawer.open(), 500);
    }
  }
}

// Initialize bundle functionality
new BundleCart();

// Export for potential use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = BundleCart;
}
